<script>
import * as BABYLON from 'babylonjs'
import 'babylonjs-procedural-textures'

export default {
  name: 'Environment',
  render: (h) => h(),
  beforeDestroy() {
    if(this.$light) this.$light.dispose()
    if(this.$gl) this.$gl.dispose()
  },
  created() {
    const scene = this.$scene = this.$parent.$scene
    const meshs = this.$meshs = this.$parent.$meshs
    const camera = this.$camera = this.$parent.$camera
    const engine = this.$engine = this.$parent.$engine

    this.createLight()
    this.setWorldSize()
    this.colors()
    this.glow()
    this.optimizer()
    // this.showOnClick()
    // this.ssao()
    // this.$scene.debugLayer.show()
  },
  methods: {
    optimizer() {
      const meshs = this.$meshs
      // this.$scene.createOrUpdateSelectionOctree()

      _.each(meshs, (mesh)=>{

        if(mesh.material) {
          mesh.material.needDepthPrePass = false

          if(mesh.name.search('o_') > -1)
            mesh.material.freeze()
        }

        mesh.freezeWorldMatrix()
      })
    },
    createLight() {
      const scene = this.$scene
      const light = new BABYLON.HemisphericLight('Light', new BABYLON.Vector3(0, 5, 0), this.$scene)
      light.specular = new BABYLON.Color3(0, 0, 0)
      light.specularPower = 0
      light.diffuse = new BABYLON.Color3(1, 1, 1)
      light.intensity = 1
      this.$light = light
    },
    setWorldSize() {

      // console.log(this.$scene);
      // console.log('======================');
      // _.each(this.$scene.rootNodes, (node)=>{
      //   console.log(node.name);
      // })
      // console.log('===== ------- =====');

      const root = this.$scene.getMeshByName('RootNode')

      // const root = this.$scene.getMeshByName('__root__')
      // __root__
      // SR_Codex
      // o_Frames
      // MR_Books_low
      // RootNode
      // c_SR_walls_08_MAT_collisions_0
      // c_SR_walls_06_MAT_collisions_0
      // console.log(root);
      // console.log('===================== ** ');
      
      const scale = .05
      root.scaling = new BABYLON.Vector3(scale, scale, scale)
    },
    showOnClick() {
      this.$scene.onPointerDown = (evt, pickResult) => {
        if(pickResult.hit)
          console.log(pickResult.pickedMesh.name)
      }
    },
    glow () {
      this.$gl = new BABYLON.GlowLayer("glow", this.$scene, { mainTextureSamples: 4 })

      const meshsGlow = [
        // 'TN_mushrooms_MAT_TN_mushrooms_0',
        // 'SR_mushrooms_MAT_SR_mushrooms_0',
        // 'TN_walls_MAT_tunnel_lights_0',
        // 'MR_lightRig_MAT_MR_luminaires_light_0',

        'SR_Codex',
        'SR_hangingLight_Light_Glass',
        'SR_hangingLight_LightGlasslight',
        'SM_MR_Mushrooms',
        'o_Vitre'
      ]

      this.$gl.customEmissiveColorSelector = (mesh, subMesh, material, result) => {
        if(meshsGlow.indexOf(mesh.name) > -1) {
          
          mesh.name == 'o_Vitre'
          ? result.set(1, 1, 1, .05)
          : result.set(.1, .3, .1, 1)   

          if(mesh.name == 'SR_hangingLight_Light_Glass' 
          || mesh.name == 'SR_hangingLight_LightGlasslight')
            result.set(1, 1, 1, 1)   
        }
        else {
          result.set(0, 0, 0, 0)
        }
      }
    },
    ssao() {
      const scene = this.$scene
      const camera = this.$camera
      const ssaoRatio = {
          ssaoRatio: 0.5,
          combineRatio: 1.0
      }

      const ssao = new BABYLON.SSAORenderingPipeline("ssao", scene, ssaoRatio)
      ssao.fallOff = 0.000001
      ssao.area = 1
      ssao.radius = 0.0001
      ssao.totalStrength = 1.0
      ssao.base = 0.5

      scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline("ssao", camera)
    },
    colors() {
      const scene = this.$scene
      const engine = this.$engine
      const camera = this.$camera

      // const pink = new BABYLON.Color3.FromHexString('#efaad5')
      // scene.clearColor = pink

      const blue = new BABYLON.Color3.FromHexString('#91a1ba')
      scene.clearColor = blue

      scene.imageProcessingConfiguration.vignetteEnabled = true
      scene.imageProcessingConfiguration.vignetteWeight = 50
      scene.imageProcessingConfiguration.vignetteCameraFov = .3

      // scene.imageProcessingConfiguration.contrast = 1.2
      // scene.imageProcessingConfiguration.exposure = 1.5
      // scene.imageProcessingConfiguration.colorCurves.globalSaturation = -10
      // scene.imageProcessingConfiguration.toneMappingEnabled = true
      // console.log(scene.imageProcessingConfiguration)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/components/world/elements/Environment.vue